import { api } from '@cwd/lib/main';

export interface JobPropertyInfo {
    Name: string;
    TypeName: string;
}

export interface JobTypeInfo {
    TypeName: string;
    DisplayName: string;
    Properties: JobPropertyInfo[];
}

export interface JobTaskItem {
    TaskId: string;
    JobTypeName: string;
    JobType: string;
    Status: string;
    CronPattern: string | null;
    Scheduled: string | null;
    IsRecurring: boolean;
    LastRun: string | null;
    JobData: Record<string, unknown> | null;
    TimeZone: string | null;
}

export interface CreateJobRequest {
    jobName: string | null;
    jobType: string;
    jobData: Record<string, unknown>;
    scheduled: string;
    cronPattern: string | null;
    isRecurring: boolean;
    timeZone: string | null;
}

export interface UpdateJobRequest {
    jobName: string | null;
    cronPattern: string | null;
    scheduled: string | null;
    isRecurring: boolean;
    jobData: Record<string, unknown>;
    timeZone: string | null;
}

export function getJobTypes(): Promise<JobTypeInfo[]> {
    return api.get('/BackOffice/Jobs/Types');
}

export function getAccountJobs(accountId: string): Promise<JobTaskItem[]> {
    return api.get(`/BackOffice/Account/${accountId}/Jobs`);
}

export function createJob(accountId: string, request: CreateJobRequest): Promise<void> {
    return api.post(`/BackOffice/Account/${accountId}/Jobs`, request);
}

export function updateJob(accountId: string, taskId: string, request: UpdateJobRequest): Promise<void> {
    return api.put(`/BackOffice/Account/${accountId}/Jobs/${taskId}`, request);
}
